import { render, staticRenderFns } from "./BedManager.vue?vue&type=template&id=77a10008"
import script from "./BedManager.vue?vue&type=script&lang=js"
export * from "./BedManager.vue?vue&type=script&lang=js"
import style0 from "./BedManager.vue?vue&type=style&index=0&id=77a10008&prod&lang=scss"
import style1 from "./BedManager.vue?vue&type=style&index=1&id=77a10008&prod&lang=scss"
import style2 from "./BedManager.vue?vue&type=style&index=2&id=77a10008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports